import React, { useState } from "react";
import Map from "./Map"; // Original Google Maps
import MapboxMap from "./MapboxMap"; // Mapbox (requires API key)
import LeafletMap from "./LeafletMap"; // OpenStreetMap (completely free)

const SmartMap = ({
  location = "both",
  height = "400px",
  provider = "leaflet",
}) => {
  const [currentProvider, setCurrentProvider] = useState(provider);
  const [error, setError] = useState(null);

  // Map provider configurations
  const providers = {
    google: {
      name: "Google Maps",
      component: Map,
      cost: "💰 Pay per use",
      features: "🌟🌟🌟🌟 Rich features, familiar UI",
      performance: "⚡⚡⚡⚡ Fast loading",
      styling: "🎨🎨🎨 Limited customization",
    },
    mapbox: {
      name: "Mapbox",
      component: MapboxMap,
      cost: "💸 50k free/month",
      features: "🌟🌟🌟🌟🌟 Advanced features",
      performance: "⚡⚡⚡⚡⚡ Excellent performance",
      styling: "🎨🎨🎨🎨🎨 Highly customizable",
    },
    leaflet: {
      name: "OpenStreetMap (Leaflet)",
      component: LeafletMap,
      cost: "✅ Completely FREE",
      features: "🌟🌟🌟🌟 Good features",
      performance: "⚡⚡⚡⚡ Good performance",
      styling: "🎨🎨🎨🎨 Very customizable",
    },
  };

  const CurrentMapComponent =
    providers[currentProvider]?.component || LeafletMap;

  const handleProviderChange = (newProvider) => {
    setError(null);
    setCurrentProvider(newProvider);
  };

  const handleMapError = (errorMessage) => {
    setError(errorMessage);
    // Fallback to Leaflet if other providers fail
    if (currentProvider !== "leaflet") {
      setCurrentProvider("leaflet");
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Map Provider Selector */}
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          zIndex: 1000,
          background: "rgba(255, 255, 255, 0.95)",
          borderRadius: "12px",
          padding: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          backdropFilter: "blur(10px)",
        }}
      >
        <select
          value={currentProvider}
          onChange={(e) => handleProviderChange(e.target.value)}
          style={{
            background: "transparent",
            border: "none",
            font: "12px system-ui",
            color: "#01727a",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          {Object.entries(providers).map(([key, provider]) => (
            <option key={key} value={key}>
              {provider.name}
            </option>
          ))}
        </select>
      </div>

      {/* Error Message */}
      {error && (
        <div
          style={{
            position: "absolute",
            top: "50px",
            right: "10px",
            zIndex: 1000,
            background: "rgba(220, 53, 69, 0.9)",
            color: "white",
            padding: "8px 12px",
            borderRadius: "8px",
            fontSize: "12px",
            maxWidth: "200px",
          }}
        >
          {error}
        </div>
      )}

      {/* Provider Info Badge */}
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          left: "10px",
          zIndex: 1000,
          background: "rgba(1, 114, 122, 0.9)",
          color: "white",
          padding: "6px 10px",
          borderRadius: "20px",
          fontSize: "11px",
          fontWeight: "500",
        }}
      >
        {providers[currentProvider]?.cost}
      </div>

      {/* Render the selected map component */}
      <CurrentMapComponent
        location={location}
        height={height}
        onError={handleMapError}
      />
    </div>
  );
};

export default SmartMap;
